export default __webpack_public_path__ + "static/media/ic_vehicles_b.24c75092.svg";